<template>
    <div class="details-block">
        <span class="details-block__heading" v-html="$options.filters.subscript(title)"></span>
        <span v-if="currency" class="details-block__content details-block__content--large ">{{text | toCurrency}}</span>
        <span v-else class="details-block__content">{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: "DetailsBlock",
        props:[
            'title',
            'text',
            'currency',
        ],
        filters: {
            toCurrency: function(value) {
                if (isNaN(parseFloat(value))) {
                    return value
                }
                let formatter = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                    minimumFractionDigits: 2
                });
                return formatter.format(parseFloat(value));
            },
        }
    }
</script>

<style scoped lang="stylus">
    .details-block
        margin-bottom 17px
        &__heading
            font-family "VWAGTheSansBold",Arial,sans-serif;
            display block
            line-height 28px
            font-size 16px
            color #004666
            margin-bottom 3px;
        &__content
            font-family "VWAGTheSansRegular",Arial,sans-serif;
            display block
            line-height 28px
            font-size 24px
            color #4c5356
            &--large
                margin-top 6px
                font-size 36px
</style>